import { Paper, PaperProps, Stack, StackProps } from '@mantine/core';
import React from 'react';

export interface IPaperStackProps {
  paperProps?: PaperProps;
  stackProps?: StackProps;
  children?: React.ReactNode;
}

/** @registry Mantine Paper wrapping a Stack; a thin convenience combo for the common "card with stacked content" layout. */
export const PaperStack: React.FC<IPaperStackProps> = ({
  paperProps,
  stackProps,
  children,
}) => {
  return (
    <Paper {...paperProps}>
      <Stack {...stackProps}>{children}</Stack>
    </Paper>
  );
};
